import styles from "./styles.scss";

interface Props {
  loading: boolean;
}

const Loader = (props: Props) => {
  if (props.loading) {
    return (
      <div className={styles.root}>
        <img src="/images/loader.svg" className={styles.image} />
      </div>
    );
  } else {
    return null;
  }
};

export default Loader;
